export default __webpack_public_path__ + "static/media/proofPoint.6a27f181.png";